import l from "../../assets/linverno.jpg";
import sugar from "../../assets/sugar.jpg";
import aussteig from "../../assets/ausstieg.jpg";
export const Upcoming = [
  {
    url: l,
    name: "L'Inverno",
    date: "2017",
    extraText: `Feature film L’inverno, Pre production  
Palme d’Or Oscar Nominated Director , award winning team numerous Oscar recipients and renowned artists 
`,
  },
  {
    url: sugar,
    name: "Sugar",
    date: "2017",
  },
];

export const released = [
  {
    url: aussteig,
    name: "Aussteig Rechts",
    date: "2014",
  },
  {
    name: "Jasmine",
    date: "2014",
  },
  {
    name: "Sin In Emotions",
    date: "2014",
  },
];

export const newsData = [
  {
    title: "Feature film L’inverno, Pre production",
    text: "Palme d’Or Oscar Nominated Director , award winning team numerous Oscar recipients and renowned artists",
    image: l,
  },
  {
    title: "US Feature Film Sugar, Pre production",
    text: "A List Director, Oscar Winning Talent",
    image: sugar, // Optional
  },
  {
    title: "US Feature Film Shepherdess",
    text: "Director attached Pre Production Development, Stage 23 @disneystudiosaustralia",
    image:
      "https://betravingknows.com/wp-content/uploads/2017/06/video-movie-placeholder-image-grey.png", // Optional
  },
  {
    title: "2024 Global Recognition Award",
    text: "Brilliance in Cinematic Arts and Business Awarded",
    image:
      "https://www.join-the-quest.co.uk/cms/resources/2024-global-recognition-award-image-2-w1200.jpg", // Optional
  },
  {
    title: "2024 Sydney Film Festival Opening Gala",
    text: "Acquired Director and Post Production partners Films L’inverno and Shepherdess @disneystudiosaustralia",
    image:
      "https://www.sff.org.au/wp-content/uploads/2024/08/Highlights_800x450.jpg", // Optional
  },
  {
    title: "FOMA Runway Showcase 2024",
    text: "FOMA intercultural runway showcase and exhibition Sydney Observatory",
    image:
      "https://www.sff.org.au/wp-content/uploads/2024/08/Highlights_800x450.jpg", // Optional
  },
  {
    title: "Sydney Opera House Film Premiere",
    text: "Sydney Opera House Film Premiere Palme d'Or Recipient from Festival de Cannes 2024",
    image:
      "https://www.sff.org.au/wp-content/uploads/2024/08/Highlights_800x450.jpg", // Optional
  },
  // {
  //   title: "Cannes Film Festival Palme d'Or Recipient 2024",
  //   // text: "FOMA intercultural runway showcase and exhibition sydney observatory",
  //   image:
  //     "https://www.sff.org.au/wp-content/uploads/2024/08/Highlights_800x450.jpg", // Optional
  // },
];

export const filmData = [
  {
    title: "L’INVERNO",
    subtitle: "Feature film L’inverno, Drama Pre-production",
    description: `Director Roland Joffe Palme d'Or Oscar Nominated DOP Dante Spinotti Oscar Nom Production Design Dante Ferretti 3 Oscars Costume Design Gabriella Pescucci Oscar Golden Globe Composer and composers of Martin Scorsese's Silence Kim and Kathryn Kluge. Cast includes Klaus Maria Brandauer Oscar Nom Tobias Moretti Olivier Martinez renowned cellist Stjepan Hauser and violinist Joshua Bell in discussion to Andrea Bocelli Matteo Bocelli Virginia Bocelli Isabelle Huppert Riccardo Scamarcio and Jason Isaacs BAFTA Joseph Fiennes and Tye Sheridan.`,
    image: l,
  },
  {
    title: "SUGAR",
    subtitle: "US Feature Film Sugar, Drama Pre-production",
    description: `Set in the 1880s Western era, Sugar follows a group of Southern plantation women as they undergo a profound transformation, discovering their inner strength, finding the hero within, on a mission of retribution. The project boasts an A-list director and Oscar-winning talent, with Christine Jeffs at the helm. The film is currently in pre-production, and discussions are underway with Oscar-nominated actress Judy Davis and Oscar winner Davine Joy Randolph to join the cast.`,
    image: sugar,
  },
  {
    title: "SHEPHERDESS",
    subtitle: "US Feature Film Shepherdess, Sci-Fi",
    description: `Shepherdess is a sci-fi feature film with Sharron Aubrey taking on the roles of actor, screenwriter, and producer. The project is currently in pre-production development, with a director already attached and development taking place at Stage 23 in Disney Studios Australia. Additionally, Sharron is involved in other films in development, including Odyssey of an Empress as director and Soul, in partnership with production collaborators.`,
    image:
      "https://betravingknows.com/wp-content/uploads/2017/06/video-movie-placeholder-image-grey.png",
  },
];
